//this is used to disply the images and quick information of the trips/others
import './tripCard.css';
import Location from '../../../assets/icons/trvto_location.svg';
import Calender from '../../../assets/icons/trvto_calendar.svg';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Carousel from '../../../components/carousel/Carousel';
import ReviewStars from '../../../components/reviewStars/ReviewStars';
import { getHikedPrice } from '../../../utils/getAmountWithTransaction';

export default function TripCard({ imageData, interested }) {
    const location = useLocation();
    const [typeSel, setTypeSel] = useState('trip');
    // const [userWishlist, setUserWishlist] = useState([]);
    // const { isAuthenticated } = useContext(UserAuthContext);
    // const { setLogButton, setLoginSec } = useContext(UserLoginSecContext);

    useEffect(() => {
        setTypeSel((prev) => prev);
    }, []);

    // useEffect(() => {
    //     fetchWishlistData(typeSel, setUserWishlist);
    // }, [typeSel, setLogButton]);

    function TripCardClick(packId) {
        // return (window.location.href = `/trip/details/${packId}`);
        //to open the details page in the new tab
        if (location.pathname.startsWith('/search-result') || location.pathname === '/') {
            localStorage.removeItem('tempOrg');
        }
        return window.open(`/h/trip/details/${packId}`, '_blank', 'noopener,noreferrer');
    }

    // const handleClick = (id) => {
    //     if (isAuthenticated) {
    //         handleWishlistClick(id, userWishlist, typeSel, setUserWishlist);
    //     } else {
    //         setLogButton(true);
    //         setLoginSec('login');
    //     }
    // };

    return imageData?.map((item, index) => {
        const { where, baseCities } = item.quickView;

        const formattedDates = Array.isArray(item?.futureDates)
            ? item.futureDates.map((date) =>
                  new Date(date).toLocaleString('en-US', { month: 'short', day: '2-digit' }).replace(',', '')
              )
            : [];

        const firstDate = formattedDates[0] || null;
        const moreDates = formattedDates.slice(1).join(' | ') || null;

        const startCityLocation = baseCities.split(',');
        const reservePrice = item.price[0]?.price.reserve || item.price[0]?.customPrice?.reserve || 0;
        const installmentPrice = item.price[0]?.instalments?.[0]?.amount || 0;
        const actualPrice = item.price[0]?.price.actual || item.price[0]?.customPrice?.perPerson || 0;

        let finalDisplayPrice;

        if (reservePrice === 0 && installmentPrice === 0) {
            // If both are 0 → fallback to actual price
            finalDisplayPrice = actualPrice;
        } else if (reservePrice > 0 && installmentPrice > 0) {
            // If both exist → take the lower one
            finalDisplayPrice = Math.min(reservePrice, installmentPrice);
        } else {
            // If only one exists → take the one that’s non-zero
            finalDisplayPrice = reservePrice || installmentPrice;
        }
        return (
            <div className={`tripCard ${interested ? 'interestedTrip' : ''}`} key={index}>
                {/* Will use later for Ads section */}
                {/* {item.fillingFast && <div className="identityTag fillingFast alignCenter">Filling Fast</div>} */}
                {/* {item.onlyFewLeft && <div className="identityTag fewLeft alignCenter">Only Few Left</div>} */}
                <Carousel imageData={item.cardImages} TripCardClick={TripCardClick} packId={item._id} />
                {/* <button className='wishlist pop-animation' onClick={() => handleClick(item._id)}>
                    {isFavorite ? <LoveRed className='wishlist-icon' /> : <LoveBlack className='wishlist-icon' />}
                </button> */}
                <div title={moreDates} className='tripCardInfo' onClick={() => TripCardClick(item._id)}>
                    <p className='tripCardName'>
                        {item?.title || 'N/A'} [{item?.days + 'D/' + item?.nights + 'N'}]
                    </p>
                    <p className='tripCardLocation'>
                        <img src={Location} alt='trvto_location' /> {where}
                    </p>
                    <p className='tripCardLocation'>
                        <strong>&nbsp;By</strong> {item.organizerName}
                    </p>
                    <p className='tripCardLocation'>
                        <img src={Location} alt='trvto_location' />
                        From :{' '}
                        {Array.isArray(startCityLocation) && startCityLocation.length > 2
                            ? `${startCityLocation.slice(0, 2).join(', ')} ...etc`
                            : startCityLocation?.join(', ')}
                    </p>
                    <p className='tripCardLocation'>
                        {item?.datesType && (
                            <>
                                <strong>&nbsp;Dates</strong>: {item?.datesType}
                            </>
                        )}

                        {item?.group && (
                            <>
                                <strong>&nbsp;Group</strong>:
                                <span style={{ fontWeight: 'bold', color: item?.group === 'vehicle' ? 'black' : '' }}>
                                    {' '}
                                    {item?.group === 'vehicle' ? 'Rides' : item?.group}
                                </span>
                            </>
                        )}
                    </p>

                    <div className='tripCardPriceDiv dateGap'>
                        {firstDate && (
                            <p className='tripCardLocation dateView'>
                                <img src={Calender} alt='trvto_location' />{' '}
                                <div className='innerDateContent'>
                                    {firstDate && firstDate}
                                    {firstDate ? <span>*Onwards</span> : <span>Custom Dates</span>}
                                </div>
                                <span className='moreDates'>
                                    {formattedDates.length > 1 && <span> | +{formattedDates.length - 1} more</span>}
                                </span>
                            </p>
                        )}
                        {item?.rating && (
                            <div className='tripCardNumInfo'>
                                <ReviewStars rating={item?.rating || 0} />
                                <span>{Math.round(item?.rating) || 0}</span>
                                {/*Enable once backend has value /*}
              {/* <p style={{ margin: 0 }}>({item.reviews} Reviews)</p> */}
                            </div>
                        )}
                    </div>
                    <div className='tripCardPriceDiv bottomMar'>
                        {/* <p className='tripPrice striked'>₹{getHikedPrice(item.price[0]?.price.actual)}</p>
                        <p className='tripPrice'>₹{item.price[0]?.price.actual}</p> */}
                        <p
                            className='tripCardLocation'
                            style={{ marginBottom: '10px', marginRight: '5px', fontWeight: '600' }}
                        >
                            Starts from
                        </p>
                        <p className='tripPrice striked'>₹{getHikedPrice(finalDisplayPrice)}</p>
                        <p className='tripPrice'>₹{finalDisplayPrice}</p>
                        <p className='tripBookingOffer'>{20}%OFF</p>
                    </div>
                    <button className='viewDetails'>Book Now</button>
                </div>
            </div>
        );
    });
}
